import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { ValidationService } from '../../../core/services/validation.service';

import { ProfileImageUploadComponent } from '../../../shared/components/profile-image-upload/profile-image-upload.component';
import { Attorney } from '../services/attorney.service';

@Component({
    selector: 'app-add-attorney',
    standalone: true,
    imports: [ReactiveFormsModule, ModalComponent, ProfileImageUploadComponent],
    templateUrl: './add-attorney.component.html',
    styleUrl: './add-attorney.component.scss'
})
export class AddAttorneyComponent implements OnChanges {
    @Input() isOpen = false;
    @Input() attorney: Attorney | null = null;
    @Output() close = new EventEmitter<void>();
    @Output() save = new EventEmitter<any>();

    attorneyForm: FormGroup;

    constructor(
        private fb: FormBuilder,
        private validationService: ValidationService
    ) {
        this.attorneyForm = this.fb.group({
            profile_image: [null],
            firm_name: ['', Validators.required],
            first_name: ['', Validators.required],
            last_name: ['', Validators.required],
            attorney_email: ['', [Validators.required, Validators.email]],
            attorney_phone: ['', Validators.required],
            firm_address: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required],
            zip_code: ['', Validators.required],
            country: ['', Validators.required],
            preferred_contact: ['', Validators.required]
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['attorney'] && this.attorney) {
            this.attorneyForm.patchValue({
                firm_name: this.attorney.firm_name,
                first_name: this.attorney.first_name || '',
                last_name: this.attorney.last_name || '',
                attorney_email: this.attorney.attorney_email,
                attorney_phone: this.attorney.attorney_phone,
                firm_address: this.attorney.firm_address,
                city: this.attorney.city || '',
                state: this.attorney.state || '',
                zip_code: this.attorney.zip_code || '',
                country: this.attorney.country || '',
                preferred_contact: this.attorney.preferred_contact,
                profile_image: this.attorney.profile_image_path
            });
        } else if (changes['isOpen'] && !this.isOpen) {
             // Reset form when modal closes (if managed here)
             // However, handleClose usually resets it.
        }
    }

    getErrorMessage(controlName: string, label: string): string | null {
        const control = this.attorneyForm.get(controlName);
        if (control && control.touched && control.errors) {
            return this.validationService.getValidatorErrorMessage(control.errors, label);
        }
        return null;
    }

    handleClose() {
        this.attorneyForm.reset();
        this.close.emit();
    }

    handleSave() {
        if (this.attorneyForm.valid) {
            this.save.emit(this.attorneyForm.value);
            this.handleClose();
        } else {
            this.markFormGroupTouched(this.attorneyForm);
        }
    }

    private markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();
            if ((control as any).controls) {
                this.markFormGroupTouched(control as FormGroup);
            }
        });
    }
}
